/**
 * Initiates our parallax effects
 *
 * @export
 * @class Parallax
 */
export class Parallax {


    /**
     * Loops through our target elements and add's them to the 
     * IntersectionObserver. When the elements scroll into view we add a class
     * after a certain delay and stop observing the element
     * 
     * @param {string} selector
     * @param {string} visibleClass
     * @memberof Parallax
     */
    constructor(selector: string, visibleClass: string, intersectionRatio = 0) {
        const elements = document.querySelectorAll(selector);
        if(elements) {

            // Create our observer and callback
            const observer = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
                $.each(entries, ({}, entry: IntersectionObserverEntry) => {
                    if(entry.intersectionRatio > intersectionRatio) {
                        const delay = Number(entry.target.getAttribute('data-delay')) * 1000 || 0;
                        setTimeout(() => {
                            entry.target.classList.add(visibleClass);
                        }, delay);

                        // Stop tracking our element
                        observer.unobserve(entry.target);
                    }
                });
            }, { threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]});

            // Add elements to our observer
            $.each(elements, ({}, element: Element) => {
                observer.observe(element);
            });
        }
    }
}
